import { cn } from '@/lib/cn';

type ProgressBarProps = {
  value: number;
  max: number;
  label: string;
  thin?: boolean;
  className?: string;
};

/** Track surface-muted, fill ink; always pair with a mono count ("3 / 6"). */
export function ProgressBar({ value, max, label, thin = false, className }: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      className={cn('overflow-hidden rounded-full bg-surface-muted', thin ? 'h-1.5' : 'h-2', className)}
    >
      <div
        className={cn('bg-ink transition-[width] duration-300', thin ? 'h-1.5' : 'h-2')}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
